import { useParams } from "react-router-dom";
import { db } from "../utils/firebase";
import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";


export default function CommunityDetailsSideBar() {
  const { community } = useParams();

  const comRef = query(
    collection(db, "Communities"),
    where("slug", "==", community)
  );

  const comMembersRef = query(
    collection(db, "Users"),
    where("communitySlug", "==", community)
  );

  const proposalRef = query(
    collection(db, "Proposals"),
    where("slug", "==", community)
  );

  const [com, setCom] = useState({});
  const [comMembers, setComMembers] = useState({});
  const [proposals, setProposals] = useState(0);
  const [verifiedMembers, setVerifiedMembers] = useState([]);

  useEffect(() => {
    const getCommunity = async () => {
      const comFromServer = await getDocs(comRef);

      setCom(comFromServer.docs[0].data());
    };

    getCommunity();

    const getCommunityMembersData = async () => {
      const comMembersFromServer = await getDocs(comMembersRef);

      comMembersFromServer.forEach((doc) => {
        if (doc.data().userTypeNumber == 2) {
          verifiedMembers.push(doc.data());
        }
      });

      setComMembers(comMembersFromServer);
    };
    getCommunityMembersData();

    const getProposals = async () => {
      const proposalsFromServer = await getDocs(proposalRef);

      setProposals(proposalsFromServer.size);
    };

    getProposals();
  }, []);


  return (
    <div>

      <img src={com.image} alt="" />

      <div className="card-body">
        <h3 className="card-title">{com.name}</h3>
        <p className="card-text"></p>
      </div>

      <ul className="list-group list-group-flush">
        <li className="list-group-item">Total Members: {comMembers.size} </li>
        <li className="list-group-item">
          Verified members: {verifiedMembers.length}
        </li>
        <li className="list-group-item"> Proposals: {proposals}</li>
      </ul>
      <br />
    </div>
  );
}
